module.exports = __webpack_public_path__ + "media/images/the-prize-title-77e9df232d1fc29d6b41478d082b78ca.png";